import { Component } from '@angular/core';

@Component({
  selector: 'app-tablacondiciones',
  templateUrl: './tablacondiciones.component.html',
  styleUrl: './tablacondiciones.component.scss'
})
export class TablacondicionesComponent {

}
